/* @ngInject */
const axletreeOptions = () => {
  const self = {}

  return self
}
export default axletreeOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/scrapping/axletreeOptions.resource.js